// extracted by mini-css-extract-plugin
export default {"logoutText":"LogOut-module--logout-text--5f99b"};